"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskGenerationResultSchema = exports.ekipmanPeriyotOnBilgiSchema = exports.ekipmanPeriyotYazSchema = exports.ekipmanPeriyotConfigSchema = exports.ekipmanTipPeriyoduSchema = exports.ekipmanPeriyotSatiriSchema = exports.taskMineListSchema = exports.equipmentDurumGecmisiSchema = exports.taskOverdueSummarySchema = exports.taskOptionsSchema = exports.taskAssignmentUpdateSchema = exports.taskAssignmentCreateSchema = exports.GOREV_TANIMI_KAPANIS_ISLEMLERI = exports.taskAssignmentSummarySchema = exports.taskOccurrenceListSchema = exports.taskOccurrenceDetailSchema = exports.gorevHedefDurumuSorguSchema = exports.gorevHedefDurumuSchema = exports.gorevHedefBilgiSchema = exports.gorevHedefEngelSchema = exports.GOREV_HEDEF_BILGI_METNI = exports.GOREV_HEDEF_ENGEL_METNI = exports.GOREV_HEDEF_BILGI_SEBEPLERI = exports.GOREV_HEDEF_ENGEL_SEBEPLERI = exports.gorevHedefKisiSchema = exports.taskOccurrenceSummarySchema = exports.taskNesneSchema = exports.EKIPMAN_DURUM_SAPKALARI = exports.GOREV_TANIM_SAPKALARI = exports.GOREV_OKUMA_SAPKALARI = exports.TASK_HEDEF_OLAMAZ_SAPKALAR = exports.taskKumeSapkalariSchema = exports.TASK_KAPANIS_DURUMLARI = exports.taskOccurrenceDurumSchema = exports.TASK_OCCURRENCE_DURUMLARI = exports.taskKumeKaynagiSchema = exports.TASK_KUME_KAYNAKLARI = exports.taskHedefTipiSchema = exports.TASK_HEDEF_TIPLERI = exports.taskPeriyotBicimiSchema = exports.TASK_PERIYOT_BICIMLERI = exports.taskKalemKaynagiSchema = exports.TASK_KALEM_KAYNAKLARI = exports.TASK_NESNE_TIPLERI = exports.EQUIPMENT_DURUM_GECISLERI = exports.equipmentDurumSchema = exports.EQUIPMENT_DURUMLARI = void 0;
exports.equipmentDurumGecisiGecerliMi = equipmentDurumGecisiGecerliMi;
exports.readKontrolPeriyoduAy = readKontrolPeriyoduAy;
exports.resolveEkipmanPeriyoduAy = resolveEkipmanPeriyoduAy;
exports.readOperasyonelKontrolGecerlilik = readOperasyonelKontrolGecerlilik;
exports.ayEkleUtc = ayEkleUtc;
exports.donemKimligi = donemKimligi;
exports.donemSonrakiVade = donemSonrakiVade;
exports.gorevAcilmaTarihi = gorevAcilmaTarihi;
exports.taskKumeSapkaIhlali = taskKumeSapkaIhlali;
exports.gorevHedefHesapSinifi = gorevHedefHesapSinifi;
exports.gorevTanimiKapanisMetni = gorevTanimiKapanisMetni;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * PERİYODİK GÖREV ATAMA MOTORU — kural katmanı (F4·S4; Kapsam §22.6a + §16.5,
 * ERD §6d; tutanak `docs/arsiv/periyodik-gorev-motoru-kararlari-v1_0.md`
 * G0-G6 · Z1-Z8).
 *
 * **TURUN TEK CÜMLESİ: TAKVİME BAĞLI İŞ GÖREV ÜRETİR, KULLANIMA BAĞLI İŞ
 * ÜRETMEZ.** Motor **nesne bazlıdır** ve nesne ya bir **ekipmandır** ya
 * **işyerinin kendisidir** (Z2).
 *
 * ⚠️ **G3 — OPERASYONEL KONTROL BU MOTORUN İŞİ DEĞİLDİR.** Kullanımda
 * tetiklenir: operatör formu doldurur, `equipment.son_operasyonel_kontrol`
 * güncellenir ve **önceden açılmış bir görev satırı YOKTUR.** Görev üreten
 * kod ayda **binlerce sahte uygunsuzluk** doğurur (20 ekipman × 3 vardiya ×
 * 30 gün = 1.800 görev/ay; ayda üç kez kullanılan seyyar vinçte 87 sahte
 * kalem). **Kök sorun:** sistem ekipmanın o vardiyada kullanılıp
 * kullanılmayacağını BİLMİYOR — vardiya düzeni sistemde tanımlı değildir
 * (bilinçli sınır, session-log madde 89).
 *
 * BURADA YAŞAYAN KURALLAR (hepsinin TEK okuyucusu var):
 *   resolveGorevPeriyodu  — Z1/G0: periyot GÖMÜLMEZ, SORULUR (@isg/db)
 *   donemKimligi          — G4: kayan VEYA takvim, kalem başına
 *   donemSonrakiVade      — vade türetmesi (kolon değil — `sonraki_vade` düştü)
 *   gorevAcilmaTarihi     — Z3: vade − uyarı eşiği
 *   readKontrolPeriyoduAy — ekipman tipinin PERİYODİK periyodu (birim AY)
 *   readOperasyonelKontrolGecerlilik — ON ÜÇÜNCÜ EKSEN (§19/11-13, birim SAAT)
 */
// ── Ekipman durumu (G5) ──────────────────────────────────────────────────────
/**
 * **İKİ DEĞER — geçici/kalıcı ayrımı YOKTUR** (07.08.2026'nın
 * `aktif`/`devre_disi`/`hurda` taslağının ✏️ revizyonu, Kapsam §16.5).
 * Ayrım bir kuralı ikiye bölüyordu; birleşince tek biçime indi: *pasiften
 * aktife dönen ekipman **KONTROL İSTER*** — hurda zaten geri dönmez, bakımdaki
 * döner. Üçüncü değer eklemek o kuralı tekrarlamaktan başka bir şey yapmaz.
 *
 * ⚠️ **ARŞİVDEN FARKI: pasiflik SALT-OKUNURLUK ÜRETMEZ** (§2.15 ile
 * karıştırma). Pasif ekipmanın künyesi düzenlenebilir, kontrol geçmişi
 * yazılabilir; **tek sonucu görev ÜRETMEMESİDİR.** İkisini aynı kapıya
 * (`assertWorkplaceWritable`) bağlama.
 */
exports.EQUIPMENT_DURUMLARI = ['aktif', 'pasif'];
exports.equipmentDurumSchema = zod_1.z.enum(exports.EQUIPMENT_DURUMLARI);
/** Kodlanan geçişler: iki yönlü (Z7 — *yanlışlıkla pasife alınan ekipman geri
 *  alınabilir*). `workplace.durum` ALLOWED_TRANSITIONS deseninin ikizi. */
exports.EQUIPMENT_DURUM_GECISLERI = [
    { from: 'aktif', to: 'pasif' },
    { from: 'pasif', to: 'aktif' },
];
function equipmentDurumGecisiGecerliMi(from, to) {
    return exports.EQUIPMENT_DURUM_GECISLERI.some((g) => g.from === from && g.to === to);
}
// ── Atama eksenleri (G0 · G1 · G4 · Z2) ─────────────────────────────────────
/**
 * **NESNE = EKİPMAN VEYA İŞYERİ (Z2).** Kütüphane kaleminin (saha turu,
 * tatbikat, kurul toplantısı) nesnesi **işyerinin KENDİSİDİR** — yeni bir
 * atama biçimi doğmaz, mevcut biçimin ikinci nesne tipidir.
 *
 * ⚠️ **BU LİSTE BİR `nesne_tipi` KOLONU DEĞİLDİR** ve şemada öyle bir kolon
 * YOKTUR: nesne bağı **tipli nullable kolonlarla** (`ekipman_id` ·
 * `isyeri_id`) + TEK CHECK ile taşınır. Hangi kolonun dolu olduğu tipi zaten
 * söyler; ayrıca enum tutmak **aynı bilgiyi ikinci kez** tutar ve çelişebilir
 * (K4 — `employment.company_id`'yi düşürürken uygulanan kuralın aynısı;
 * emsal `action`'ın DÖRT tip güvenli koludur, orada da ayırt edici enum
 * YOKTUR). Bu tip yalnız KOD tarafının okuma kolaylığıdır, satırda durmaz.
 */
exports.TASK_NESNE_TIPLERI = ['ekipman', 'isyeri'];
/**
 * **G0/Z1 — periyodun hangi çözümleyici koluna sorulacağı.** Bugün yalnız
 * `ekipman_tipi` dolu; `yukumluluk_kalemi` **S5'te** yükümlülük kütüphanesi
 * gelince açılır ve o gün **motora DOKUNULMAZ.**
 */
exports.TASK_KALEM_KAYNAKLARI = ['ekipman_tipi', 'yukumluluk_kalemi'];
exports.taskKalemKaynagiSchema = zod_1.z.enum(exports.TASK_KALEM_KAYNAKLARI);
/**
 * **G4 — PERİYOT BİÇİMİ KALEM BAŞINA.** G2 bunu zorunlu kıldı: *"kaçırıldı"*
 * diyebilmek için dönemin **kapanmış** olması gerekir.
 *
 * **Tek biçime indirmenin bedeli iki yönlüdür:** hepsi `kayan` olursa Kasım'da
 * tatbikat yapan işyeri **takvim yılını boş geçirir**; hepsi `takvim` olursa
 * Mart'ta yapılan yıllık kontrol **Aralık'ta dokuz ay erken** istenir.
 */
exports.TASK_PERIYOT_BICIMLERI = ['kayan', 'takvim'];
exports.taskPeriyotBicimiSchema = zod_1.z.enum(exports.TASK_PERIYOT_BICIMLERI);
/** **G1 — HEDEF KİŞİ VEYA KÜME** (07.08'in "kişi VEYA operatör listesi"
 *  XOR'unun ✏️ genişlemesi). Yedekleme zinciri YOK. */
exports.TASK_HEDEF_TIPLERI = ['kisi', 'kume'];
exports.taskHedefTipiSchema = zod_1.z.enum(exports.TASK_HEDEF_TIPLERI);
/**
 * **G1 — KÜME İKİ KAYNAK BİLİR, AMA TEK KOLDUR.** Üç ayrı kol aynı davranışı
 * üç yerde tekrarlardı; görev **kümeden kim doldurursa doldursun** kapanır.
 *
 * **FARK BİLİNSİN — ikisi aynı şey DEĞİLDİR:**
 *   operator_listesi : **ELLE** kurulur ve elle güncellenir → bakım ister;
 *                      ayrılan operatör listede kalırsa görev **yanlış
 *                      kişiye** düşer ve **uyarı YOKTUR** (bakım müşterinin
 *                      yükümlülüğüdür — §22.6/G7).
 *   sapka_bahce      : **KENDİLİĞİNDEN** değişir (uzman ayrılırsa küme kendini
 *                      günceller) → bakım istemez ama **sorumlu sabit
 *                      değildir.**
 */
exports.TASK_KUME_KAYNAKLARI = ['operator_listesi', 'sapka_bahce'];
exports.taskKumeKaynagiSchema = zod_1.z.enum(exports.TASK_KUME_KAYNAKLARI);
/**
 * **G2 + Z5 — BİR AÇIK, ÜÇ KAPANIŞ DURUMU.**
 *
 *   bekliyor  : açık görev
 *   yapildi   : **güncel dönem**, bugünkü kontrolle kapandı
 *   kacirildi : **geçmiş dönem**, aynı kontrolle kapandı — *kayıt "KAPANDI"
 *               der ama **"YERİNE GETİRİLDİ" DEMEZ***
 *   gecersiz  : **pasife alınan ekipmanın** açık görevleri
 *
 * ⚠️ **`gecersiz` ≠ `kacirildi` — ÜÇÜ AYRI ANLAM TAŞIR.** Pasif ekipmanın
 * görevini `kacirildi` yazan kod **OLMAYAN bir uygunsuzluk** üretir ve
 * uygunluk oranını haksız yere düşürür: kimse yapmadı, ama **yapması da
 * gerekmiyordu.** Geçmişte GERÇEKTEN kaçırılmış kayıtlar yerinde kalır,
 * geriye dönük temizlenmez.
 */
exports.TASK_OCCURRENCE_DURUMLARI = ['bekliyor', 'yapildi', 'kacirildi', 'gecersiz'];
exports.taskOccurrenceDurumSchema = zod_1.z.enum(exports.TASK_OCCURRENCE_DURUMLARI);
/** Kapanış durumları — `bekliyor` dışındaki üçü. Açık görev süzgeci bunun
 *  değil, `bekliyor`un kendisidir (tek token, dallanma yok). */
exports.TASK_KAPANIS_DURUMLARI = [
    'yapildi',
    'kacirildi',
    'gecersiz',
];
// ── Sözlük kural ekseni okuyucuları (readUyariEsigiGun deseni) ──────────────
//
// Ortak sözleşme: bozuk/eksik değer OKUMAYI DÜŞÜRMEZ — kalem o kural
// bakımından "tanımsız" sayılır. Eksen listesi §19/11 gereği sonradan
// DEĞİŞTİRİLEMEZ; buraya yeni anahtar eklemek ÜRÜN kararıdır.
function kuralNesnesi(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null || Array.isArray(kurallar))
        return null;
    return kurallar;
}
/**
 * `kontrol_periyodu_ay` — ekipman tipinin **PERİYODİK** kontrol periyodu,
 * birim **AY** (madde 25 / §19/11-4; `+n month` — artık yıl kayması yok).
 *
 * ✏️ **REVİZE 26.08.2026 (F4·S10 ARTÇI — 91-2'nin revizyonu; ürün sahibi:
 * *"İş ekipmanlarını işyerleri kendileri yükler; yüklerken periyodu da
 * belirlesinler. Holdingden gitmesine gerek yok bu kuralın."*).** Bu
 * fonksiyon artık **ÜRÜN KÜTÜPHANESİ KALEMİNİN** kuralını okur — tenant
 * nüshasının değil. Nüsha bu anahtarı **TAŞIMAZ** (dağıtım indirmez,
 * migration temizledi): taşısaydı ekranda düzenlenebilir ama hiçbir yerde
 * OKUNMAYAN bir alan olurdu ve *"kaydettim, değişmedi"* der.
 *
 * ✏️ **ÖNCEKİ REVİZYON 26.08.2026 (F4·S10·B — madde 91) KORUNUR:** periyot
 * **TEK EKSENDEDİR ve eksen TİPTİR**; `equipment.kontrol_periyodu_gun`
 * KALKTI. ⚠️ **KAYDA SÜRE YAZAN KOLON GERİ AÇILMAZ** ("geçici olarak",
 * "yalnız bu ekipmanda" diye açılan kolon, kapanan hatanın birebir
 * tekrarıdır).
 */
function readKontrolPeriyoduAy(kurallar) {
    const nesne = kuralNesnesi(kurallar);
    if (!nesne)
        return null;
    const parsed = zod_1.z.number().int().positive().safeParse(nesne['kontrol_periyodu_ay']);
    return parsed.success ? parsed.data : null;
}
/**
 * **EKİPMAN KONTROL PERİYODU — TEK ÇÖZÜMLEYİCİ (91-2; ERD §8 çözümleme
 * zinciri).** `resolveUyariEsigi` / `resolveGorevPeriyodu` deseninin
 * **ÜÇÜNCÜ ÜYESİ.**
 *
 * **İKİ ADIM, ÜÇÜNCÜ ADIM YOK:**
 *   1. **işyeri × tip** satırı (`workplace_equipment_type_period`) — VARSA,
 *   2. **kütüphanenin ÖNERİSİ** (`EKIPMAN_TIP_KUTUPHANESI` — KİLİTLİ ürün
 *      verisi, `kutuphane_ref` ile bulunur) — satır YOKSA.
 *
 * ✏️ **REVİZE 26.08.2026 (F4·S10 ARTÇI — ürün sahibi): ORTADAKİ KATMAN
 * KALKTI.** Aynı gün sabah üç katman vardı ve ortadaki *"müşterinin holding
 * genelinde belirlediği süre"* (tip nüshasının `kurallar.kontrol_periyodu_ay`
 * alanı) idi. Ürün sahibi onu kaldırdı: **ekipmanı yükleyen işyeri, süresini
 * de o anda belirler** — kural holdingden gitmez. Ortada kalan katman, hiç
 * kimsenin doldurmadığı bir formu zorunlu kılıyordu.
 *
 * ⚠️ **KÜTÜPHANE ÖNERİSİ ARTIK ÇÖZÜMLEMENİN İKİNCİ ADIMIDIR** — sabahki
 * şerh onu *"ikinci doğruluk kaynağı açar"* diye reddediyordu; o gerekçe
 * ortadaki katman VARKEN geçerliydi (aynı bilgi iki yerden okunurdu).
 * Katman kalkınca öneri **TEK KALAN** kaynaktır ve okunmazsa hiçbir tipin
 * varsayılan süresi olmaz. **KİLİTLİ ürün verisidir, müşteri düzenleyemez.**
 *
 * ⚠️ **KAYIT SÜRE TAŞIMAZ (91-1).** Girdide "bu ekipmanın kendi periyodu"
 * diye bir kol YOKTUR ve açılmaz; `equipment.kontrol_periyodu_gun` tam olarak
 * bu yüzden kaldırıldı (F4·S10·B).
 *
 * ⚠️ **GEVŞETME SERBEST (91-3):** işyeri değeri önerinin **üstünde**
 * olabilir — burada karşılaştırma, işaret, uyarı ya da 422 **YOKTUR.**
 * Öneriden sapmayı işaretlemek, önerinin bir TABAN olduğunu iddia etmektir
 * (Kapsam §19/7 sınır paragrafı: ilke MEVZUAT kaynaklı kurallar içindir).
 *
 * **FAIL-LOUD:** hiçbir katman süre vermiyorsa `null` döner — çağıran
 * `sonraki_kontrol`ü NULL bırakır ve PTW o ekipmana *"uygundur" DEMEZ*
 * (`son_kontrol` boşluğuyla aynı davranış). **Varsayılan periyot UYDURULMAZ.**
 * Müşterinin kendi açtığı tipin (kütüphane ref'i yok) önerisi de yoktur:
 * o tipin süresi **ilk ekipman yüklenirken işyerinde belirlenir.**
 */
function resolveEkipmanPeriyoduAy(girdi) {
    const isyeri = zod_1.z.number().int().positive().safeParse(girdi.isyeriPeriyoduAy);
    if (isyeri.success)
        return isyeri.data;
    const oneri = zod_1.z.number().int().positive().safeParse(girdi.kutuphaneOnerisiAy);
    return oneri.success ? oneri.data : null;
}
/**
 * `operasyonel_kontrol_gecerlilik` — **ON ÜÇÜNCÜ KURAL EKSENİ** (§19/11-13,
 * G6). Operasyonel (kullanım öncesi) kontrolün **geçerlilik SÜRESİ**, birim
 * **SAAT** (gün birimi *"vardiya başı"* prosedürünü ifade edemez — bir günde
 * üç vardiya vardır).
 *
 * ⚠️ **BOŞSA UYARI HİÇ ÜRETİLMEZ** (`isyeri_oran` deseni: *sistem, kuralını
 * bilmediği sıklığa "eksik" demez*). Kütüphane bu anahtarı **BOŞ dağıtır** —
 * değer uydurulmaz.
 *
 * ⚠️ **PERİYODİK PERİYODUN YERİNE GEÇMEZ** (Z8): madde 25'in *"ekipman tipi
 * TEK periyot taşır"* kilidi **PERİYODİK** kontrolündü — bu **kilit ihlali
 * değil, sınırının netleşmesidir.** **BU EKSEN GÖREV ÜRETMEZ** (G3): motor
 * onu OKUMAZ; yalnız *"bu ekipmanın operasyonel kontrolü hâlâ geçerli mi"*
 * sorusunu cevaplar ve cevabı **UYARIDIR, KAPI DEĞİLDİR** (K12 aynen).
 */
function readOperasyonelKontrolGecerlilik(kurallar) {
    const nesne = kuralNesnesi(kurallar);
    if (!nesne)
        return null;
    const parsed = zod_1.z.number().int().positive().safeParse(nesne['operasyonel_kontrol_gecerlilik']);
    return parsed.success ? parsed.data : null;
}
// ── Tarih aritmetiği (G4) ───────────────────────────────────────────────────
//
// UTC gün ekseni — `deriveSonrakiKontrol` / `deriveYetkinlikBitis` ile aynı
// eksen. Ay ekleme `+n month`; ay sonu taşması ayın son gününe çekilir.
function utcGun(tarih) {
    return new Date(Date.UTC(tarih.getUTCFullYear(), tarih.getUTCMonth(), tarih.getUTCDate(), 0, 0, 0, 0));
}
function ayEkleUtc(tarih, ay) {
    const gun = utcGun(tarih);
    const hedefGun = gun.getUTCDate();
    gun.setUTCMonth(gun.getUTCMonth() + ay);
    if (gun.getUTCDate() !== hedefGun)
        gun.setUTCDate(0);
    return gun;
}
function ikiBasamak(sayi) {
    return sayi < 10 ? `0${sayi}` : String(sayi);
}
function isoGun(tarih) {
    return utcGun(tarih).toISOString().slice(0, 10);
}
/**
 * **G4 — DÖNEM KİMLİĞİ.** *"Kaçırıldı"* ancak dönem **kapanınca** yazılabilir;
 * dönemin kimliği biçime göre değişir:
 *
 *   takvim  : periyot 12 ayın katıysa takvim YILI (`2026`), değilse takvim
 *             AYI (`2026-03`) — vadenin düştüğü takvim birimi.
 *   kayan   : vadenin kendisi (`2026-03-14`) — kayan biçimde dönem *"son
 *             kapanıştan vadeye kadar"* olduğu için kimliği vade taşır.
 *
 * Kimlik SATIRDA durur (`task_occurrence.donem`) çünkü gecikme raporu
 * *"hangi dönem kaçtı"* sorusunu **satır satır** sorar.
 */
function donemKimligi(vade, bicim, periyotAy) {
    if (bicim === 'kayan')
        return isoGun(vade);
    const gun = utcGun(vade);
    if (periyotAy % 12 === 0)
        return String(gun.getUTCFullYear());
    return `${gun.getUTCFullYear()}-${ikiBasamak(gun.getUTCMonth() + 1)}`;
}
/**
 * **VADE TÜRETİLİR, KOLON DEĞİLDİR** (`equipment.sonraki_kontrol` deseni —
 * ERD §6d'de `sonraki_vade` kolonu bilinçle DÜŞTÜ: kolon tutulsaydı doluluk
 * `task_occurrence`ta, vade kolonda durur ve **iki doğruluk kaynağı** doğardı,
 * K4).
 *
 *   kayan  : `baslangic + periyotAy` — geçerlilik yapıldığı tarihten işler.
 *   takvim : takvim biriminin **SONU** — periyot 12 ayın katıysa yılın son
 *            günü, değilse ayın son günü. *Dönem içinde bir kez yapılır;
 *            vade dönemin bitişidir.*
 */
function donemSonrakiVade(baslangic, periyotAy, bicim) {
    if (bicim === 'kayan')
        return ayEkleUtc(baslangic, periyotAy);
    const ileri = ayEkleUtc(baslangic, periyotAy);
    if (periyotAy % 12 === 0) {
        return new Date(Date.UTC(ileri.getUTCFullYear(), 11, 31));
    }
    // Ayın son günü: bir sonraki ayın 0'ıncı günü.
    return new Date(Date.UTC(ileri.getUTCFullYear(), ileri.getUTCMonth() + 1, 0));
}
/**
 * **Z3 — GÖREVİN AÇILMA ANI: vade − uyarı eşiği.** Kapanır kapanmaz bir
 * sonrakini açan kod, listeyi **UZAK GELECEKLE** doldurur — her kapanan
 * yıllık görev anında **bir yıl sonrasının** görevini doğurur ve liste
 * okunmaz hâle gelir.
 *
 * Eşik `resolveUyariEsigi` ailesinden gelir (@isg/db) — buraya sayı GÖMÜLMEZ.
 */
function gorevAcilmaTarihi(vade, esikGun) {
    const gun = utcGun(vade);
    gun.setUTCDate(gun.getUTCDate() - esikGun);
    return gun;
}
// ── Küme şapka listesi (G1) ─────────────────────────────────────────────────
/**
 * `kume_kaynagi = 'sapka_bahce'` kolunun şapka listesi. **BAHÇE KOLONU
 * AÇILMADI ve bu bir karardır:** bahçe **NESNEDEN** gelir (ekipmanın/işyerinin
 * kendi işyeri + lokasyonu) ve kesişimi `resolveNotificationRecipients`
 * çözer — **İKİNCİ bahçe filtresi yazılmaz** (§2.17). Atamaya ayrıca bahçe
 * yazmak, nesnenin zaten söylediğini ikinci kez söylemek olurdu (K4).
 */
exports.taskKumeSapkalariSchema = zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)).min(1);
/** İzleyici hiçbir göreve hedef OLAMAZ — salt-okunurluğun genel kuralı
 *  (§2.14); yüklenici temsilcisi de iç görev almaz (kayıt İÇ KULLANICI işi). */
exports.TASK_HEDEF_OLAMAZ_SAPKALAR = ['viewer', 'contractor_rep'];
function taskKumeSapkaIhlali(sapkalar) {
    const yasak = sapkalar.filter((s) => exports.TASK_HEDEF_OLAMAZ_SAPKALAR.includes(s));
    if (yasak.length > 0)
        return `Bu şapkalar göreve hedef olamaz: ${yasak.join(', ')}`;
    return null;
}
// ── T10 — UÇ → ŞAPKA LİSTELERİ (Kapsam §20.5; F4·S5·B2) ─────────────────────
//
// ⚠️ **BU LİSTELER TENANT YAPILANDIRMASI DEĞİLDİR.** Olay (`olay_inceleme`),
// eğitim (`egitim_kaydi`), risk (`risk_degerlendirme`) modüllerinde asıl kapı
// tenant listesiydi ve guard geniş tutuluyordu; **beşinci motorda ürün sahibi
// SABİT bir matris verdi** (T10, 21.08.2026) — anahtar açılmadı. Yeni bir
// tenant anahtarı uydurmak, ürün sahibinin vermediği bir kararı vermek olur.
//
// Desen `SAGLIK_OKUMA_SAPKALARI`nınkiyle aynıdır: tek kaynak burada durur,
// uçlar `...LISTE` demetiyle yayar, envanter testi ikisini TAM EŞİTLİKLE
// kilitler.
/**
 * **T10/#1-#2-#3-#6 — OKUMA KÜMESİ.** Görev listesi · görev detayı ·
 * dashboard *"süresi geçenler"* bloğu · ekipman durum geçiş geçmişi.
 * **İzleyici DAHİLDİR** (genel GET kuralı; görev satırı kişisel veri
 * taşımaz — sağlığın DAR listesi buraya UZANMAZ).
 */
exports.GOREV_OKUMA_SAPKALARI = [
    'holding_admin',
    'isg_specialist',
    'isg_technician',
    'company_admin',
    'location_manager',
    'viewer',
];
/**
 * **T10/#4 — GÖREV TANIMI.** ⚠️ **İSG TEKNİSYENİ YOKTUR:** *teknisyen görev
 * TANIMLAMAZ, yalnız UYGULAR.* Okuma kümesinde vardır, burada yoktur ve bu
 * **U11'in ("teknisyen aksiyon tarafında uzmanla aynı sınıfta") istisnası
 * DEĞİLDİR** — orada açılan şey aksiyon AÇMAKTI, burada tartışılan şey
 * **başkasına periyodik iş yüklemek.** Listeye teknisyen eklemek ürün
 * kararıdır.
 *
 * `holding_admin` guard listesinde durur (bahçesizdir, her şeyi yazar);
 * matrisin *"İSG uzmanı · lokasyon yön."* satırı **bahçeli** şapkaları sayar.
 */
exports.GOREV_TANIM_SAPKALARI = [
    'holding_admin',
    'isg_specialist',
    'location_manager',
];
/**
 * **T10/#5 — EKİPMAN AKTİF ↔ PASİF GEÇİŞİ.** *"Ekipmanı yöneten birim"in
 * karşılığı LOKASYON YÖNETİCİSİDİR* — ayrı bir *"ekipman sorumlusu"* şapkası
 * **AÇILMADI** (§20.4: şapka listesi ŞİŞMEZ).
 */
exports.EKIPMAN_DURUM_SAPKALARI = exports.GOREV_TANIM_SAPKALARI;
// ── API ŞEMALARI (F4·S5·B2 — motor yüzeyi) ──────────────────────────────────
/** Nesne — hangi kolonun dolu olduğu tipi söyler (ERD §12/30: enum YOK). */
exports.taskNesneSchema = zod_1.z.object({
    tip: zod_1.z.enum(exports.TASK_NESNE_TIPLERI),
    id: zod_1.z.uuid(),
    ad: zod_1.z.string(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
});
/**
 * Görev satırı. ⚠️ **`vadesiGecti` TÜRETİLMİŞ İŞARETTİR** (`kazaDosyasiEksikMi`
 * sınıfı) — kolon değildir ve ekran ikinci kez hesaplamaz.
 */
exports.taskOccurrenceSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    atamaId: zod_1.z.uuid(),
    nesne: exports.taskNesneSchema,
    kalemAd: zod_1.z.string(),
    donem: zod_1.z.string(),
    vadeTarihi: zod_1.z.iso.date(),
    durum: exports.taskOccurrenceDurumSchema,
    vadesiGecti: zod_1.z.boolean(),
});
/**
 * Görev detayı (T10/#2). ⚠️ **P5 — SEKME YOK:** bölümler alt alta durur;
 * yanıt tek parçadır ve ekran onu bölmez.
 *
 * ⚠️ **`atananDisindaMi` YALNIZ KİŞİ HEDEFİNDE anlamlıdır** (Z4) — küme
 * hedefinde sunucu `false` yazar ve ekran o notu çizmez.
 */
/**
 * **GÖREV ATAMA UYARISI — HEDEF DURUMU** (sessiz 403 paketi, 29.09.2026;
 * Kapsam §22.6a). *Sistem hedefin görevi gerçekten yapıp yapamayacağını
 * kontrol eder; eksik varsa UYARIR AMA ATAR.*
 *
 * ⚠️ **TÜRETİLİR, SAKLANMAZ** — kolon açılmadı. Kişiye sonradan hesap
 * verilirse işaret kendiliğinden kalkar; hesap kaldırılırsa geri gelir.
 * Yüklem TEKTİR (`@isg/db gorevHedefDurumu`): atama anındaki uyarı, tanım
 * listesi ve görev detayı aynı yüklemi çağırır.
 *
 * - `engeller` — **UYARI: EYLEM GEREKTİRİR.** Kişi görevi göremiyor ve bu
 *   kendiliğinden düzelmeyecek (hesabı yok · hesabı kapalı). Her satır `sebep`
 *   taşır (`GOREV_HEDEF_ENGEL_SEBEPLERI`); ekran sebebe göre ÇÖZÜM YOLUNU
 *   söyler (madde 288). ⚠️ *Uyarı yalnız eylem gerektireni söyler:* kendiliğinden
 *   çözülecek bir hâli uyarı diye gösteren ekran alarm yorgunluğu üretir.
 * - `bilgiler` — **BİLGİ: EYLEM GEREKTİRMEZ.** Uyarı rengi/ikonu KULLANILMAZ.
 *   İki sebep (`GOREV_HEDEF_BILGI_SEBEPLERI`): `giris_yapmadi` (hesap var, kişi
 *   henüz ilk girişini yapmadı — ilk girişte görevi sahiplenir) · `yetki_yok`
 *   (form doldurma şapkası ya da nesneyi kapsayan bahçesi yok; görevi **atama
 *   yetkisiyle** yapacak — kilitli karar 42.1).
 */
exports.gorevHedefKisiSchema = zod_1.z.object({ personId: zod_1.z.uuid(), adSoyad: zod_1.z.string() });
/**
 * **HESABIN DURUMU — İKİ SINIF** (madde 288, yetki paketi artçısı 29.09.2026;
 * Kapsam §22.6a GA-3 · GA-4). Dört hâl de ÖLÇÜLDÜ (hesabın oluşma yolları: ilk
 * giriş + provizyon + e-posta eşleşmesi · kişiyle birlikte doğan pasif hesap ·
 * bekleyen hesabın elle bağlanması):
 *
 *   ENGEL (uyarı — eylem gerektirir)
 *   eposta_yok    : kişinin hesabı yok, kişi kaydında e-posta da yok — ilk
 *                   girişte açılan hesap kişiye KENDİLİĞİNDEN bağlanamaz.
 *   hesap_yok     : kişinin hesabı yok, kişi kaydında e-posta VAR — şirket
 *                   hesabıyla ilk girişte hesap açılır ve e-postadan bağlanır.
 *   hesap_kapali  : hesap kapatılmış — giriş 403 verir. ⚠️ Uygulamada hesabı
 *                   yeniden açmanın yolu TANIMLI DEĞİLDİR; ekran bunu söyler.
 *
 *   BİLGİ (eylem gerektirmez)
 *   giris_yapmadi : hesap kişiyle birlikte doğmuş (pasif), kişi hiç giriş
 *                   yapmamış — ilk girişte sahiplenilir.
 *
 * ✏️ **REVİZYON İZİ (GA-4 — ürün sahibi kararı 30.09.2026; yetki artçısı 2).**
 * *30.09.2026'da (yetki paketi artçısı — gözetimsiz alınan okuma O2)
 * `giris_yapmadi` ENGEL sayılmıştı: kişi ilk girişe kadar görevi göremez.*
 * **Aynı gün şöyle revize edildi:** hiç giriş yapmamış hesap UYARI DEĞİL,
 * BİLGİDİR. **Gerekçe:** kurulum döneminde kimse henüz giriş yapmamışken her
 * kişi hedefli atama uyarı taşır → uyarı yorgunluğu → gerçek uyarı da okunmaz.
 * Bu hâl kendiliğinden çözülür (ilk girişte kişi görevi sahiplenir); yapılacak
 * bir iş yoktur.
 *
 * ⚠️ **ÇALIŞANA DAVET PAKETİ YOKTUR** (yalnız yüklenici temsilcisinde —
 * §18.2); ekran var olmayan bir yolu önermez.
 */
exports.GOREV_HEDEF_ENGEL_SEBEPLERI = ['eposta_yok', 'hesap_yok', 'hesap_kapali'];
exports.GOREV_HEDEF_BILGI_SEBEPLERI = ['giris_yapmadi', 'yetki_yok'];
/**
 * Hesabın durumundan SINIF + SEBEP — **TEK YÜKLEM** (`@isg/db gorevHedefDurumu`
 * bunu çağırır; atama satırı · tanım listesi · görev detayı aynı sınıflamayı
 * okur). `null`: hesap açık ve kullanılabilir — söylenecek bir şey yok.
 */
function gorevHedefHesapSinifi(girdi) {
    if (!girdi.hesap) {
        return { sinif: 'engel', sebep: girdi.kisiEpostasiVar ? 'hesap_yok' : 'eposta_yok' };
    }
    if (girdi.hesap.aktif)
        return null;
    return girdi.hesap.girisYapti
        ? { sinif: 'engel', sebep: 'hesap_kapali' }
        : { sinif: 'bilgi', sebep: 'giris_yapmadi' };
}
/**
 * **UYARI METNİ — SEBEP BAŞINA ÇÖZÜM YOLU** (madde 288; D2 dili). Her cümle
 * ÖLÇÜLEN mekanizmayı söyler; var olmayan bir yol (çalışana davet · ekrandan
 * hesap açma) ÖNERİLMEZ. `hesap_kapali`de yol yoktur ve metin bunu söyler.
 *
 * ⚠️ Metin burada yaşar, ekranda değil: atama satırı · tanım listesi · görev
 * detayı aynı cümleyi çizer ve test cümleyi buradan okur.
 */
exports.GOREV_HEDEF_ENGEL_METNI = {
    eposta_yok: {
        rozet: 'Kişinin hesabı yok',
        kumeRozeti: 'Hesabı olmayan üye var',
        cozum: 'Görevi göremez. Kişi kaydına e-posta yazın; kişi şirket hesabıyla ilk kez giriş yaptığında görevi görecek.',
    },
    hesap_yok: {
        rozet: 'Kişinin hesabı yok',
        kumeRozeti: 'Hesabı olmayan üye var',
        cozum: 'Görevi henüz göremez. Şirket hesabıyla ilk kez giriş yaptığında hesabı açılır ve görevi görecek.',
    },
    hesap_kapali: {
        rozet: 'Hesabı kapalı',
        kumeRozeti: 'Hesabı kapalı üye var',
        cozum: 'Giriş yapamaz, görevi göremez. Kapalı hesabı yeniden açmanın yolu henüz tanımlı değil.',
    },
};
/**
 * **BİLGİ METNİ — EYLEM GEREKTİRMEYEN HÂLLER** (GA-4). Uyarı dili, rengi ve
 * ikonu KULLANILMAZ; ekran soluk tek satır çizer. `kisi`: kişi hedefinde tam
 * cümle. `kume`: küme hedefinde cümlenin gövdesi — ekran ardına üye adlarını
 * ekler (`<gövde>: Ad, Ad.`).
 */
exports.GOREV_HEDEF_BILGI_METNI = {
    giris_yapmadi: {
        kisi: 'İlk girişinde görevi görecek.',
        kume: 'İlk girişinde görevi görecek',
    },
    yetki_yok: {
        kisi: 'Bu kişinin bu lokasyonda şapka/bahçesi yok; görevi atama yetkisiyle yapacak.',
        kume: 'Bu lokasyonda şapka/bahçesi yok; görevi atama yetkisiyle yapacak',
    },
};
exports.gorevHedefEngelSchema = exports.gorevHedefKisiSchema.extend({
    sebep: zod_1.z.enum(exports.GOREV_HEDEF_ENGEL_SEBEPLERI),
});
exports.gorevHedefBilgiSchema = exports.gorevHedefKisiSchema.extend({
    sebep: zod_1.z.enum(exports.GOREV_HEDEF_BILGI_SEBEPLERI),
});
exports.gorevHedefDurumuSchema = zod_1.z.object({
    engeller: zod_1.z.array(exports.gorevHedefEngelSchema),
    bilgiler: zod_1.z.array(exports.gorevHedefBilgiSchema),
});
/** Atama anındaki önizleme — kaydetmeden önce aynı yüklem (`GET`, yazmaz). */
exports.gorevHedefDurumuSorguSchema = zod_1.z
    .object({
    ekipmanId: zod_1.z.uuid().optional(),
    isyeriId: zod_1.z.uuid().optional(),
    hedefTipi: exports.taskHedefTipiSchema,
    hedefPersonId: zod_1.z.uuid().optional(),
    kumeKaynagi: exports.taskKumeKaynagiSchema.optional(),
    kumeSapkalar: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)).optional(),
})
    .superRefine((deger, ctx) => {
    if ([deger.ekipmanId, deger.isyeriId].filter(Boolean).length !== 1) {
        ctx.addIssue({ code: 'custom', message: 'Tam olarak bir nesne seçilmeli' });
    }
    if (deger.hedefTipi === 'kisi' && !deger.hedefPersonId) {
        ctx.addIssue({ code: 'custom', message: 'Kişi hedefinde kişi seçilmeli' });
    }
    if (deger.hedefTipi === 'kume' && !deger.kumeKaynagi) {
        ctx.addIssue({ code: 'custom', message: 'Küme hedefinde küme kaynağı seçilmeli' });
    }
});
exports.taskOccurrenceDetailSchema = exports.taskOccurrenceSummarySchema.extend({
    hedefTipi: exports.taskHedefTipiSchema,
    hedefAd: zod_1.z.string().nullable(),
    /** Atamanın hedef durumu (uyarı + bilgi) — tanım listesiyle AYNI yüklem. */
    hedefDurumu: exports.gorevHedefDurumuSchema,
    kumeKaynagi: exports.taskKumeKaynagiSchema.nullable(),
    kapanisAt: zod_1.z.string().nullable(),
    dolduranAd: zod_1.z.string().nullable(),
    atananDisindaMi: zod_1.z.boolean(),
    formSubmissionId: zod_1.z.uuid().nullable(),
    /**
     * T3 (türetme paketi — bulgu 93): görevin formu ve DOLDURMA KAPISI. *Formu
     * doldur* görev detayından açılır; işyeri ve ekipman görevden türetilir.
     * Kapı sunucuda (form doldurma kapısı → arşiv → dönem açık); yazamayan
     * sebep satırı görür (K-63) — ekran şapka listesi yazmaz.
     */
    formTemplateId: zod_1.z.uuid(),
    doldurmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    periyotBicimi: exports.taskPeriyotBicimiSchema,
    /** Aynı atamanın diğer dönemleri — ızgaranın satır karşılığı (G2-a). */
    gecmisDonemler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        donem: zod_1.z.string(),
        vadeTarihi: zod_1.z.iso.date(),
        durum: exports.taskOccurrenceDurumSchema,
        /** Türetilmiş işaret — tek yüklem, sunucuda (madde 296). */
        vadesiGecti: zod_1.z.boolean(),
    })),
});
/** P4 — SAYFALAMA (sonsuz kaydırma DEĞİL): toplam sayı görünür kalır. */
exports.taskOccurrenceListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.taskOccurrenceSummarySchema),
    toplam: zod_1.z.number().int(),
    sayfa: zod_1.z.number().int(),
    sayfaBoyutu: zod_1.z.number().int(),
});
/**
 * Görev tanımı satırı (T10/#4). İki TÜRETİLMİŞ işaret taşır:
 * - `periyotAy` — `resolveGorevPeriyodu` çözebildi mi (null = kalem kuralsız,
 *   görev ÜRETİLMEZ; fail-loud'un ekrandaki yüzü).
 * - `hedefsiz` — küme boşaldı (G6). Bildirim de üretir; rozet onun aynasıdır.
 */
exports.taskAssignmentSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    nesne: exports.taskNesneSchema,
    formTemplateId: zod_1.z.uuid(),
    kalemAd: zod_1.z.string(),
    kalemKaynagi: exports.taskKalemKaynagiSchema,
    /** C1 — işyeri nesnesinde: görevin bağlı olduğu yükümlülük kaleminin adı. */
    yukumlulukKalemAd: zod_1.z.string().nullable(),
    periyotBicimi: exports.taskPeriyotBicimiSchema,
    periyotAy: zod_1.z.number().int().nullable(),
    hedefTipi: exports.taskHedefTipiSchema,
    hedefPersonId: zod_1.z.uuid().nullable(),
    hedefAd: zod_1.z.string().nullable(),
    kumeKaynagi: exports.taskKumeKaynagiSchema.nullable(),
    kumeSapkalar: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)),
    aktif: zod_1.z.boolean(),
    hedefsiz: zod_1.z.boolean(),
    /** Görev atama uyarısı — TÜRETİLİR (kolon yok); engel + bilgi ayrı. */
    hedefDurumu: exports.gorevHedefDurumuSchema,
    /**
     * ⚠️ **ASKI = TÜRETİLEN HÂL, SAKLANAN DURUM DEĞİL** (F4·S6 · T15 —
     * Kapsam §22.5c). `true` ise sebebi TEKTİR: **şablonu gizlendi**
     * (arşivlendi). Şablon geri gösterilince bayrak KENDİLİĞİNDEN düşer ve
     * üretim devam eder.
     *
     * ⚠️ **YENİ DURUM TOKEN'I AÇILMADI** ve `aktif`E BİNDİRİLMEDİ: `aktif`
     * kullanıcının KENDİ anahtarıdır; iki hâl karışsaydı *"geri gelince
     * çalışır"* sözü tutulamazdı (kullanıcının bilinçli kapattığı tanım da
     * açılırdı). ⚠️ **Askıdaki tanım listede GÖRÜNÜR** — sessizce düşmez.
     */
    askida: zod_1.z.boolean(),
    /**
     * Tanımın AÇIK (`bekliyor`) görev sayısı — sunucuda `acikGorevFiltresi`nden
     * sayılır; tanım kapanınca/silinince geçersiz kılınan kümenin AYNI koşulu
     * (madde 293). Ekran *Kapat* / *Tanımı sil* penceresinde bu sayıyı söyler.
     */
    acikGorevSayisi: zod_1.z.number().int(),
});
/**
 * **TANIMI KAPATMA / SİLME — ONAY PENCERESİNİN METNİ** (madde 293, yetki
 * artçısı 2 — ürün sahibi kararı 30.09.2026; Kapsam §22.6a GT-2).
 *
 * Tanım kapanınca ve silinince açık görevleri `gecersiz` kapanır (GT-1); ekran
 * bunu İŞLEMDEN ÖNCE söyler. *Kapat* tek tıklık bir düğmeydi: yanlışlıkla
 * kapatıp açan kullanıcı o dönemin görevini kaybediyor ve bunu hiçbir yerden
 * öğrenemiyordu (§2.40).
 *
 * - Açık görev VARSA pencere sayıyı söyler; kapatmada ayrıca yeniden açmanın
 *   geçersiz dönemi GERİ GETİRMEDİĞİNİ söyler (davranış doğrudur ve değişmedi —
 *   yalnız söylenir).
 * - Açık görev YOKSA pencere sayı söylemez, işlemin kendisini onaylatır.
 *
 * ⚠️ **SAYI SUNUCUDAN GELİR** (`taskAssignmentSummary.acikGorevSayisi`) — ekran
 * kendi saymaz. Metin burada yaşar, ekranda değil; test cümleyi buradan okur.
 */
exports.GOREV_TANIMI_KAPANIS_ISLEMLERI = ['kapat', 'sil'];
function gorevTanimiKapanisMetni(islem, acikGorevSayisi) {
    const gecersiz = `Bu tanımın ${acikGorevSayisi} açık görevi geçersiz sayılacak. Kapanmış görevler tarihçede kalır.`;
    if (islem === 'kapat') {
        return {
            baslik: 'Tanımı kapat',
            satirlar: acikGorevSayisi > 0
                ? [
                    gecersiz,
                    'Tanım yeniden açılırsa geçersiz sayılan dönemler geri gelmez; sıradaki dönemin görevi üretilir.',
                ]
                : ['Bu görev tanımı kapatılacak; kapalıyken görev üretmez.'],
            onay: 'Kapat',
        };
    }
    return {
        baslik: 'Tanımı sil',
        satirlar: acikGorevSayisi > 0 ? [gecersiz] : ['Bu görev tanımı silinecek.'],
        onay: 'Tanımı sil',
    };
}
/**
 * Görev tanımı girdisi. **NESNE XOR** ve **HEDEF XOR** şemada da zorlanır —
 * DB CHECK son savunmadır, ilk savunma burasıdır (tek kural, iki kilit).
 *
 * ⚠️ `kalemKaynagi` girdide YOKTUR: nesne ekipmansa `ekipman_tipi`, işyeriyse
 * `yukumluluk_kalemi` — türetilebilen bir alanı sormak, çelişebilen ikinci bir
 * doğruluk kaynağı açmaktır (K4).
 *
 * ✏️ **TUR 8 / C1 — `yukumlulukKalemRef` GİRDİYE GELDİ ve İŞYERİ NESNESİNDE
 * ZORUNLUDUR.** Kolon F4·S4'te açılmış, S11·B'de okunmuş, ama **hiçbir uç onu
 * YAZMIYORDU**: işyeri nesneli her atama `yukumluluk_kalem_ref = NULL` ile
 * doğuyor, `resolveGorevPeriyodu` *"periyot uydurulmaz"* diyerek atlıyor ve
 * motor onu **`periyotsuzAtama` sayacında sessizce** geçiyordu — kullanıcı
 * görev tanımladığını sanıp hiç görev almıyordu (§2.40: *"belgede var, kodun
 * yarısı var, yolu hiç yok"*). Zorunlu olması **fail-loud**tur: periyodu
 * çözülemeyecek bir atama artık **hiç doğmaz.**
 *
 * ⚠️ **REF NÜSHA ID'sidir, kütüphane ref'i DEĞİL** — kural müşterinin
 * düzenlediği satırda yaşar ve müşterinin **kendi kalemi de** görev
 * taşıyabilmelidir.
 */
exports.taskAssignmentCreateSchema = zod_1.z
    .object({
    ekipmanId: zod_1.z.uuid().nullable().optional(),
    isyeriId: zod_1.z.uuid().nullable().optional(),
    /** İşyeri nesnesinde ZORUNLU; ekipman nesnesinde YASAK (aşağıda). */
    yukumlulukKalemRef: zod_1.z.uuid().nullable().optional(),
    formTemplateId: zod_1.z.uuid(),
    periyotBicimi: exports.taskPeriyotBicimiSchema,
    hedefTipi: exports.taskHedefTipiSchema,
    hedefPersonId: zod_1.z.uuid().nullable().optional(),
    kumeKaynagi: exports.taskKumeKaynagiSchema.nullable().optional(),
    kumeSapkalar: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)).optional(),
})
    .superRefine((deger, ctx) => {
    const nesneSayisi = [deger.ekipmanId, deger.isyeriId].filter(Boolean).length;
    if (nesneSayisi !== 1) {
        ctx.addIssue({
            code: 'custom',
            message: 'Tam olarak bir nesne seçilmeli (ekipman veya işyeri)',
        });
    }
    // C1 — İŞYERİ NESNESİ BİR YÜKÜMLÜLÜK KALEMİ TAŞIMAK ZORUNDADIR: periyodu
    // ondan gelir. ⚠️ Ekipman nesnesinde YASAK — orada periyot ekipman
    // tipinden gelir ve iki kaynak yan yana durursa hangisinin okunacağı
    // belirsizleşir (`kalemKaynagi`nin türetilmesinin sebebi).
    if (deger.isyeriId && !deger.yukumlulukKalemRef) {
        ctx.addIssue({ code: 'custom', message: 'İşyeri görevinde yükümlülük kalemi seçilmeli' });
    }
    if (deger.ekipmanId && deger.yukumlulukKalemRef) {
        ctx.addIssue({
            code: 'custom',
            message: 'Ekipman görevinde yükümlülük kalemi seçilmez — periyot ekipman tipinden gelir',
        });
    }
    if (deger.hedefTipi === 'kisi') {
        if (!deger.hedefPersonId)
            ctx.addIssue({ code: 'custom', message: 'Kişi hedefinde kişi seçilmeli' });
        if (deger.kumeKaynagi)
            ctx.addIssue({ code: 'custom', message: 'Kişi hedefinde küme kaynağı olmaz' });
        return;
    }
    if (deger.hedefPersonId) {
        ctx.addIssue({ code: 'custom', message: 'Küme hedefinde kişi seçilmez' });
    }
    if (!deger.kumeKaynagi) {
        ctx.addIssue({ code: 'custom', message: 'Küme hedefinde küme kaynağı seçilmeli' });
    }
    if (deger.kumeKaynagi === 'sapka_bahce') {
        const sapkalar = deger.kumeSapkalar ?? [];
        if (sapkalar.length === 0) {
            ctx.addIssue({
                code: 'custom',
                message: 'Şapka+bahçe kümesinde en az bir şapka seçilmeli',
            });
        }
        const ihlal = taskKumeSapkaIhlali(sapkalar);
        if (ihlal)
            ctx.addIssue({ code: 'custom', message: ihlal });
    }
});
/** Düzenleme: nesne DEĞİŞMEZ (kaydın kimliğidir — eğitimde tür/işyeri kilidi
 *  ile aynı sınıf). Yanlış nesne seçilmişse tanım silinir, yenisi açılır. */
exports.taskAssignmentUpdateSchema = zod_1.z
    .object({
    formTemplateId: zod_1.z.uuid().optional(),
    periyotBicimi: exports.taskPeriyotBicimiSchema.optional(),
    hedefTipi: exports.taskHedefTipiSchema.optional(),
    hedefPersonId: zod_1.z.uuid().nullable().optional(),
    kumeKaynagi: exports.taskKumeKaynagiSchema.nullable().optional(),
    kumeSapkalar: zod_1.z.array(zod_1.z.enum(shared_types_1.ROLE_TYPES)).optional(),
    aktif: zod_1.z.boolean().optional(),
})
    .strict();
exports.taskOptionsSchema = zod_1.z.object({
    /** Aktif ekipmanlar (pasif ekipmana yeni tanım açılmaz — görev üretmez). */
    ekipmanlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), workplaceId: zod_1.z.uuid(), workplaceAd: zod_1.z.string() })),
    isyerleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    /**
     * C1 — işyeri nesnesine tanım açarken seçilecek yükümlülük kalemleri.
     * ⚠️ **YALNIZ `periyodik` VE GİZLİ OLMAYANLAR:** sürekli kalem görev
     * üretmez, gizli kalem yeni referans almaz (§19/9). Listeyi genişleten
     * kod, periyodu olmayan bir kaleme vade koydurur.
     */
    yukumlulukKalemleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    formSablonlari: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    personeller: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), adSoyad: zod_1.z.string() })),
    /** Ekran düğme/soluk satır çizecek mi — karar SUNUCUDAN (§2.6f deseni). */
    tanimlayabilir: zod_1.z.boolean(),
});
/**
 * **DASHBOARD "SÜRESİ GEÇENLER" BLOĞU (T8).**
 *
 * ⚠️ **KONU EKSENİNDE KONUŞUR:** satır bir NESNEDİR (*"12 ekipmanın periyodik
 * kontrolü geçti"*), bir KİŞİ DEĞİL. **Şemada kişi alanı YOKTUR ve
 * eklenmez** — eklendiği an bu, G7'nin (§22.2/10) ekran tarafından sessizce
 * geri alınmasıdır: *sistem kimin geciktirdiğini bildirmez.*
 */
exports.taskOverdueSummarySchema = zod_1.z.object({
    toplam: zod_1.z.number().int(),
    satirlar: zod_1.z.array(zod_1.z.object({
        nesne: exports.taskNesneSchema,
        kalemAd: zod_1.z.string(),
        gecikmisDonem: zod_1.z.number().int(),
        enEskiVade: zod_1.z.iso.date(),
    })),
});
// ⚠️ GEÇİŞ GİRDİSİ ŞEMASI BURADA DEĞİL: `equipmentDurumGecisSchema` F4·S4'te
// `index.ts`e yazıldı (ekipman şemalarının yanına). İkinci bir kopya açmak,
// "gerekçe zorunlu" kuralını iki yere bölerdi — uç oradakini çağırır.
/** T10/#6 — geçiş geçmişi (değişmez log; `workplace_status_transition` ikizi). */
exports.equipmentDurumGecmisiSchema = zod_1.z.object({
    equipmentId: zod_1.z.uuid(),
    ad: zod_1.z.string(),
    durum: exports.equipmentDurumSchema,
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    /** Geçiş yapılabilir mi — düğme görünürlüğü SUNUCUDAN (§2.6f). */
    gecisYapabilir: zod_1.z.boolean(),
    /** Pasife alınırsa kapanacak AÇIK görev sayısı — ekran bunu ÖNCEDEN söyler
     *  (kullanıcı `gecersiz` kapanışın olacağını bilmeli). */
    acikGorevSayisi: zod_1.z.number().int(),
    gecisler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        oncekiDurum: exports.equipmentDurumSchema,
        yeniDurum: exports.equipmentDurumSchema,
        gerekce: zod_1.z.string(),
        createdAt: zod_1.z.string(),
        yapanAd: zod_1.z.string().nullable(),
    })),
});
/**
 * **T9 — İŞLERİM'İN GÖREV KOLU.** Kişi hedefli ve küme hedefli görevler
 * **TEK LİSTEDE**, ayrılmadan: *tatbikat gerçekten uzmanın işidir; küme
 * hedefini ayırmak uzmanın kendi işini kendi listesinde görmemesine yol
 * açardı.* Ayırt edici alan yoktur ve eklenmez.
 */
exports.taskMineListSchema = zod_1.z.array(zod_1.z.object({
    id: zod_1.z.uuid(),
    kalemAd: zod_1.z.string(),
    nesneAd: zod_1.z.string(),
    vadeTarihi: zod_1.z.iso.date(),
    vadesiGecti: zod_1.z.boolean(),
}));
// ── EKİPMAN KONTROL PERİYODU YAPILANDIRMASI (F4·S10 ARTÇI — 91-2 revizyonu) ─
//
// ⚠️ **TEK YAZMA YOLU KALDI ve bu bir ÜRÜN KARARIDIR (26.08.2026).**
// Sabah iki yazma yolu vardı; ortadaki (*"holding geneli süre"* = tip
// nüshasının `kurallar.kontrol_periyodu_ay` alanı, sözlük ucundan yazılırdı)
// **KALDIRILDI.** Geriye **işyeri × tip satırı** kaldı:
//   · **kütüphane ÖNERİR** — KİLİTLİ ürün verisi, çözümlemenin İKİNCİ adımı,
//   · **işyeri BELİRLER** — `workplace_equipment_type_period` satırı.
//
// ⚠️ **AYRI PERİYOT YETKİSİ YOKTUR:** ekipman tanımlayabilen (bahçe
// denetimli mevcut kapı), o işyerinde o tipin periyodunu da belirler.
//
// ⚠️ **KÜTÜPHANE ÖNERİSİ EKRANDA GÖRÜNÜR, KAPI DEĞİLDİR (91-3):** gevşetme
// serbesttir — işaret, uyarı, gerekçe ya da 422 **YOKTUR.**
/** İşyeri × tip periyot satırı — okuma yüzü. */
exports.ekipmanPeriyotSatiriSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    equipmentTipId: zod_1.z.uuid(),
    equipmentTipAd: zod_1.z.string(),
    kontrolPeriyoduAy: zod_1.z.number().int().positive(),
});
/** Tip + kütüphanenin ÖNERİSİ. ⚠️ **NÜSHANIN KURALI ARTIK YOK:**
 *  `kontrolPeriyoduAy` ve `kurallarHam` alanları bilerek DÜŞTÜ — ekranda
 *  düzenlenip hiçbir yerde okunmayan bir alan *"kaydettim, değişmedi"* der. */
exports.ekipmanTipPeriyoduSchema = zod_1.z.object({
    tipId: zod_1.z.uuid(),
    ad: zod_1.z.string(),
    /**
     * Kütüphanenin ÖNERİSİ (`kutuphane_ref` kalemi) — çözümleme zincirinin
     * **İKİNCİ ADIMI.** Müşterinin kendi açtığı tipte `null`: o tipin süresi
     * ilk ekipman yüklenirken işyerinde belirlenir.
     */
    onerilenAy: zod_1.z.number().int().positive().nullable(),
});
exports.ekipmanPeriyotConfigSchema = zod_1.z.object({
    isyerleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    tipler: zod_1.z.array(exports.ekipmanTipPeriyoduSchema),
    isyeriSatirlari: zod_1.z.array(exports.ekipmanPeriyotSatiriSchema),
});
/** İşyeri satırı yazma. `kontrolPeriyoduAy: null` → satır KALDIRILIR ve tip
 *  kütüphane ÖNERİSİNE döner (ERD §8: satır ya bir süre taşır ya hiç yoktur —
 *  "bu işyerinde kontrol istemez" demenin yolu periyot ayarı DEĞİLDİR). */
exports.ekipmanPeriyotYazSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    equipmentTipId: zod_1.z.uuid(),
    kontrolPeriyoduAy: zod_1.z.number().int().positive().nullable(),
});
/**
 * **EKİPMAN EKLEME AKIŞININ ÖN BİLGİSİ (artçı 1c).** Form tip seçilince bunu
 * sorar: *bu işyerinde bu tipin süresi zaten var mı, yoksa ne önerelim.*
 *
 * ⚠️ **KARAR SUNUCUDA (§2.16):** `yazabilir` ekranda hesaplanmaz — bahçe
 * kapısı yalnız guard'dadır, ekran görünümü sadeleştirir.
 */
exports.ekipmanPeriyotOnBilgiSchema = zod_1.z.object({
    /** Bugün geçerli süre (işyeri satırı → kütüphane önerisi); hiçbiri yoksa null. */
    cozumlenenAy: zod_1.z.number().int().positive().nullable(),
    /** İşyeri × tip satırı VAR MI — varsa form SORMAZ, gösterir. */
    isyeriSatiriVar: zod_1.z.boolean(),
    /** Kütüphane önerisi — formun ÖN DOLU değeri. */
    onerilenAy: zod_1.z.number().int().positive().nullable(),
    /** Kullanıcı bu işyerinde periyot satırı yazabilir mi (bahçe kapısı). */
    yazabilir: zod_1.z.boolean(),
});
/**
 * Görev üretiminin elle tetiğinin sonucu (Tur 3 / F1 artçısı) — motorun
 * sayımının aynısı; ekran/entegrasyon *"kaç görev doğdu"* diyebilsin.
 */
exports.taskGenerationResultSchema = zod_1.z.object({
    yeniGorev: zod_1.z.number().int().nonnegative(),
    mevcutGorev: zod_1.z.number().int().nonnegative(),
    periyotsuzAtama: zod_1.z.number().int().nonnegative(),
    atlananAtama: zod_1.z.number().int().nonnegative(),
});
//# sourceMappingURL=gorev.js.map